<template>
  <div class="container mt-1">
    <div class="row" v-if="err.length">
      <div class="col">
        <ul class="list-group">
          <li class="list-group-item bg-warning" v-for="e in err" :key="e">
            {{ e }}
          </li>
        </ul>
      </div>
    </div>
    <div class="row d-flex align-items-center">
      <div class="col">
        <input
          type="text"
          class="form-control"
          v-model.trim="name"
          placeholder="Team name"
        />
      </div>
      <div class="col">
        <input
          type="text"
          class="form-control"
          v-model.trim="email"
          placeholder="Email"
        />
      </div>
      <div class="col">
        <input
          type="text"
          class="form-control"
          v-model.number="wallet"
          placeholder="Wallet"
        />
      </div>
      <div class="col">
        <button class="btn btn-sm btn-primary" @click="addTeam()">Add</button>
      </div>
    </div>
  </div>
</template>
<script setup>
import { useStore } from "@/store/index";
import supabase from "@/supabase/config";
import { ref, defineEmits, onMounted } from "vue";
const emit = defineEmits(["teamAdded"]);
const store = useStore();
const err = ref([]);
const name = ref("");
const email = ref("");
const wallet = ref(0);
onMounted(() => {
  fetchWallet();
});
const fetchWallet = async () => {
  let { data: auctions, error } = await supabase
    .from("auctions")
    .select("*")
    .eq("id", store.live_auction);
  wallet.value = auctions[0].wallet_size;
};
const addTeam = async () => {
  checkTeamConditions();
  var teamObj = {
    auction_id: store.live_auction,
    name: name.value,
    bid_email: email.value,
    wallet: wallet.value,
  };
  if (!err.value.length) {
    const { data, error } = await supabase
      .from("teams")
      .insert([teamObj])
      .select();
    if (error) {
      err.value.push(error.message);
      setTimeout(() => {
        err.value = [];
      }, 1000);
    } else {
      emit("teamAdded");
    }
  }
};
const checkTeamConditions = () => {
  err.value = [];
  if (!name.value) {
    err.value.push("Name cannot be blank");
  }
  if (!email.value) {
    err.value.push("Email cannot be blank");
  }
  if (!wallet.value) {
    err.value.push("Wallet cannot be blank");
  }
};
</script>
